import { TestResultsTable } from "./_components/TestResultsTable";

export default function UniversityTestResultsPage() {
  return (
    <TestResultsTable
      isAlumni={false}
      heading="PGM Program Test Results"
      body="Search for or view all current student test results associated with this PGM University Program"
      searchPlaceholder="Search Students"
      testId="test-results-table"
    />
  );
}
